// extracted by mini-css-extract-plugin
export var blink = "_a8-2";
export var cursor = "_a8-1";
export var reactMarkdown = "_a8-3";
export var streamingText = "_a8-0";